import React from "react";

type PROPS = {
  reRenderKey?: number;
  initValue?: string;
  items: { label: string; value: string }[];
  onSelect?: (id: string) => void;
  disabled?: boolean;
  leaveText?: boolean;
  maxLength?: number;
};

const SuggestSelect: React.FC<PROPS> = (props) => {
  const focus = React.useRef(false);
  const hover = React.useRef(false);

  const [value, setValue] = React.useState("");
  const [items, setItems] = React.useState<{ label: string; value: string }[]>(
    []
  );
  const [dropDownFlg, setDropDownFlg] = React.useState(false);

  const updateDropDownFlg = () => {
    if (dropDownFlg) {
      if (!focus.current && !hover.current) {
        setDropDownFlg(false);
      }
    } else {
      if (focus.current || hover.current) {
        setDropDownFlg(true);
      }
    }
  };

  React.useEffect(() => {
    const value = props.initValue ?? "";
    console.log(`init: [${value}]`);
    setValue(value);

    const tmp = props.items.filter((v) => v.label.includes(value));
    setItems(tmp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.reRenderKey, props.initValue]);

  React.useEffect(() => {
    setItems(props.items);
  }, [props.items]);

  return (
    <div className="relative">
      <input
        className="w-full"
        value={value}
        onChange={(e) => {
          const value = e.target.value;
          setValue(value);
          if (value === "" && props.onSelect) {
            props.onSelect("");
          }

          const tmp = props.items.filter((v) => v.label.includes(value));
          setItems(tmp);
        }}
        onFocus={() => {
          focus.current = true;
          updateDropDownFlg();
        }}
        onBlur={() => {
          focus.current = false;
          updateDropDownFlg();
        }}
        disabled={props.disabled}
        maxLength={props.maxLength}
      />
      {dropDownFlg && (
        <div
          className="absolute flex flex-col bg-white border border-b-slate-600 min-w-[50%] z-10 max-h-[32rem] overflow-auto"
          onMouseOver={() => {
            hover.current = true;
            updateDropDownFlg();
          }}
          onMouseOut={() => {
            hover.current = false;
            updateDropDownFlg();
          }}
        >
          {items.map((item, index) => {
            return (
              <div
                key={index}
                className="px-8 py-2 border hover:bg-slate-200 cursor-pointer"
                onClick={(e) => {
                  if (props.leaveText) {
                    setValue(item.label);
                  } else {
                    setValue("");
                  }

                  if (props.onSelect) {
                    props.onSelect(item.value);
                  }
                  hover.current = false;
                  updateDropDownFlg();
                }}
              >
                {item.label}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SuggestSelect;
